// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator shift_management`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'
import features from 'modules/core/store/collections/features'
import locations from 'modules/locations/store/collections/locations'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import workAreas from 'modules/locations/store/collections/workAreas'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companyHolidays, {}] /* Referenced by 204 cases in this module */,
    [features, {}] /* Referenced by 11256 cases in this module */,
    [locations, {}] /* Referenced by 5914 cases in this module */,
    [memberships, {}] /* Referenced by 84 cases in this module */,
    [teams, {}] /* Referenced by 279 cases in this module */,
    [workAreas, {}] /* Referenced by 6136 cases in this module */,
  ] /* Generated file 👉 artifacts/shift_management-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
